import { Filter } from 'lucide-react';

import { FormGroup } from '@/components/FormGroup';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';
import { Platform, Status } from '@/services/CustomerService';

interface Filters {
  searchTerm: string | null;
  platform: Platform | null;
  status: Status | null;
}

interface CustomersFilterProps {
  onFiltersChange: (partial: Partial<Filters>) => void;
  filters: Filters;
}

export function CustomersFilter({
  onFiltersChange,
  filters,
}: CustomersFilterProps) {
  function handleStatusChange(value: string) {
    const status = value === 'all' ? null : (value as Status);
    onFiltersChange({ status });
  }

  function handlePlatformChange(value: Platform | 'all') {
    const platform = value === 'all' ? null : value;
    onFiltersChange({ platform });
  }

  return (
    <div className="flex items-end gap-4">
      <div className="flex-1">
        <FormGroup>
          <Select
            value={filters.status ?? 'all'}
            onValueChange={handleStatusChange}
          >
            <SelectTrigger>
              <div className="flex items-center gap-2">
                <Filter className="h-4 w-4 text-muted-foreground" />
                <SelectValue placeholder="Status" />
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value={Status.ACTIVE}>Active</SelectItem>
              <SelectItem value={Status.INACTIVE}>Inactive</SelectItem>
            </SelectContent>
          </Select>
        </FormGroup>
      </div>

      <div className="flex-1">
        <FormGroup>
          <Select
            value={filters.platform || 'all'}
            onValueChange={handlePlatformChange}
          >
            <SelectTrigger>
              <div className="flex items-center gap-2">
                <Filter className="h-4 w-4 text-muted-foreground" />
                <SelectValue placeholder="Platform" />
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Platforms</SelectItem>
              <SelectItem value="VTEX">VTEX</SelectItem>
              <SelectItem value="SHOPIFY">Shopify</SelectItem>
              <SelectItem value="NONE">None</SelectItem>
            </SelectContent>
          </Select>
        </FormGroup>
      </div>
    </div>
  );
}
